import locale from 'antd/es/date-picker/locale/vi_VN';
import classNames from 'classnames/bind';
import moment from 'moment';
import 'moment/locale/vi';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import bookingAPI from '~/api/BookingAPI';
import categoryServiceAPI from '~/api/CategoryServiceAPI';
import comboServiceAPI from '~/api/ComboServiceAPI';
import serviceAPI from '~/api/ServiceAPI';
import { SVGS } from '~/assets/assetsPath';
import ComboServiceBooking from '~/components/ComboServiceBooking';
import config from '~/config';
import { payments } from '~/constants/payments';
import PageNotFound from '~/pages/PageNotFound';
import { disabledDate, getNumberWithCommas } from '~/utils';
import styles from './DoubleSchedule.module.scss';
import CreateScheduleModal from '~/components/FormCreateSchedule';
import branchAPI from '~/api/BranchAPI';
import VouchersModal from '~/components/VouchersModal';
import voucherAPI from '~/api/VoucherAPI';
import {
    Breadcrumb,
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    Layout,
    Modal,
    notification,
    Radio,
    Row,
    Select,
    Space,
    Tag,
    TimePicker,
} from 'antd';
// import { DownOutlined } from '@ant-design/icons';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { updateInfoScheduleStore } from '~/store/actions/ScheduleAction';

const { Content } = Layout;
const { Option, OptGroup } = Select;
const { TextArea } = Input;

const cx = classNames.bind(styles);

export default function DoubleSchedule() {
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const schedule = useSelector((state) => state.schedule.infoSchedule);

    const userInfo = useSelector((state) => state.user.userInfo);

    const [check, setCheck] = useState(true);

    const { booking_id } = useParams();

    const isLogin = userInfo?.id || '';

    const phone_booking = localStorage.getItem('phone_booking');

    const [form] = Form.useForm();
    const initialValues = {
        name: userInfo?.fullname || '',
        phone: userInfo?.phone || phone_booking || '',
        email: userInfo?.email || '',
        date: moment(),
    };

    const [payment, setPayment] = useState(schedule?.payment || 'CASH');

    const [totalPrice, setTotalPrice] = useState(0);

    // selected service
    const [serviceIdList, setServiceIdList] = useState(schedule?.serviceIdList || []);
    const [serviceCurrentList, setServiceCurrentList] = useState(schedule?.serviceCurrentList || []);

    // service returns
    const [categoryServiceList, setCategoryServiceList] = useState([]);
    const [serviceList, setServiceList] = useState([]);

    const [oldComboServiceOrder, setOldComboServiceOrder] = useState([]);

    const [isShowModalCreate, setIsShowModalCreate] = useState(false);
    const [latestBooking, setLatestBooking] = useState(null);

    const [branchList, setBranchList] = useState([]);
    const [branchSelected, setBranchSelected] = useState(schedule?.branchSelected || '');

    const [disableSubmit, setDisableSubmit] = useState(false);

    // Voucher
    const [isShowVouchers, setIsShowVouchers] = useState(false);
    const [voucherList, setVoucherList] = useState([]);
    const [voucherSelected, setVoucherSelected] = useState({});
    const voucherApply = JSON.parse(localStorage.getItem('voucherSubmit'));
    const [voucherSubmit, setVoucherSubmit] = useState({ ...voucherApply } || {});

    const [pricePayment, setPricePayment] = useState(0);
    const [priceDiscount, setPriceDiscount] = useState(0);

    const [checkLoaded, setCheckLoaded] = useState(false);

    const updateInfoSchedule = () => {
        dispatch(
            updateInfoScheduleStore({
                serviceIdList,
                serviceCurrentList,
                branchSelected,
                payment,
                voucherSubmit,
                date: form.getFieldValue('date'),
                time: form.getFieldValue('time'),
                message: form.getFieldValue('message'),
            }),
        );
    };

    const getListCategoryService = async () => {
        try {
            const res = await categoryServiceAPI.getList({
                fields: '["$all", {"services": ["$all", {"unit": ["$all"]}]}]',
            });
            const resList = res.results.objects.rows;
            const newList = resList.map((item) => ({
                ...item,
                is_show: false,
            }));
            const newServiceList = newList.map((item) => item.services).flat();
            const newServiceList02 = newServiceList.map((item) => ({
                ...item,
                amount: 1,
            }));
            setCategoryServiceList(newList);
            setServiceList(newServiceList02);
        } catch (error) { }
    };

    const handleGetInfoBooking = async () => {
        try {
            if (booking_id) {
                const res = await bookingAPI.findOne(booking_id, {
                    fields: '["$all"]',
                });
                if (res.code === 200) {
                    const resObj = res.results.object;
                    setBranchSelected(schedule?.branchSelected || resObj?.branch_id || '');
                    form.setFieldsValue({
                        name: resObj.name,
                        phone: resObj.phone,
                        branch: schedule?.branchSelected || resObj?.branch_id || '',
                        date: schedule?.date || moment(),
                        time: schedule?.time || null,
                        message: schedule?.message || '',
                    });
                    const booking_details = resObj?.booking_details;
                    // Lay ra nhung service khong thuoc comboService
                    const otherServicesTemp = booking_details.filter((item) => !item.combo_service_id);
                    let otherServices = [];
                    // Xu ly cac dich vu da xoa khoi he thong se khong show ra nua
                    for (const otherService of otherServicesTemp) {
                        for (const cate of categoryServiceList) {
                            for (const service of cate.services) {
                                if (service.id === otherService.service_id) {
                                    const params = {
                                        fields: '["$all", {"unit": ["$all"]}]',
                                    };
                                    const resService = await serviceAPI.getOneServiceAPI(
                                        otherService.service_id,
                                        params,
                                    );
                                    otherService.price = resService.results.object.price;
                                    otherService.discount = resService.results.object.discount;
                                    otherService.title = resService.results.object.title;
                                    otherService.unit_id = resService.results.object.unit_id;
                                    otherService.unit = resService.results.object.unit;
                                    otherServices.push(otherService);
                                    break;
                                }
                            }
                        }
                    }
                    for (const item of otherServices) {
                        item.amount = 1;
                        // item.amount = item.count;
                    }

                    const oldServices = schedule?.serviceCurrentList;
                    let otherIds = [];
                    if (oldServices?.length) {
                        otherServices = oldServices;
                        for (let i = 0; i < otherServices?.length; i++) {
                            otherIds.push(otherServices[i].id);
                        }
                    } else {
                        for (let i = 0; i < otherServices?.length; i++) {
                            otherIds.push(otherServices[i].service_id);
                        }
                    }

                    setServiceIdList(otherIds);
                    setServiceCurrentList([...otherServices]);

                    const totalPriceSubService = otherServices.reduce(
                        (a, b) => (a += (+b.price - b.discount) * b.amount),
                        0,
                    );
                    let totalPriceService = 0;
                    if (totalPriceSubService) {
                        totalPriceService = totalPriceSubService;
                    }
                    setTotalPrice(totalPriceService);

                    if (categoryServiceList?.length) {
                        if (!totalPriceService || totalPriceService < voucherSubmit?.minimum_price) {
                            setVoucherSubmit({});
                            localStorage.removeItem('voucherSubmit');
                        }
                    }

                    // Lay ra nhung service thuoc comboService
                    const otherComboServices = booking_details.filter((item) => item.combo_service_id);
                    setOldComboServiceOrder([...otherComboServices]);
                } else {
                    setServiceIdList([]);
                    setServiceCurrentList([]);
                    setTotalPrice(0);
                    setBranchSelected('');
                    setVoucherSubmit({});
                    localStorage.removeItem('voucherSubmit');
                }
                setCheckLoaded(true);
            }
        } catch (err) {
            console.log(err);
            setVoucherSubmit({});
            localStorage.removeItem('voucherSubmit');
        }
    };

    const handleSelectService = (values) => {
        setCheck(false);
        setServiceIdList(values);
        let newServiceList = [];
        for (let i = 0; i < values?.length; i++) {
            for (let j = 0; j < serviceList?.length; j++) {
                if (values[i] === serviceList[j].id) {
                    newServiceList.push(serviceList[j]);
                }
            }
        }
        setServiceCurrentList(newServiceList);

        const totalPriceSubService = newServiceList.reduce((a, b) => (a += (+b.price - b.discount) * b.amount), 0);
        let totalPriceService = 0;
        if (totalPriceSubService) {
            totalPriceService = totalPriceSubService;
        }
        setTotalPrice(totalPriceService);
        if (!totalPriceService || totalPriceService < voucherSubmit?.minimum_price) {
            setVoucherSubmit({});
            localStorage.removeItem('voucherSubmit');
        }
    };

    const handleShowServices = (id) => {
        setCategoryServiceList((prev) => {
            return prev.map((item) => {
                if (item.services.length > 0 && item.id === id) {
                    item.is_show = !item.is_show;
                }
                return item;
            });
        });
    };

    const handleClose = (e, id) => {
        const newTags = serviceIdList.filter((tag) => tag !== id);
        setServiceIdList(newTags);

        let newCurrentService = serviceCurrentList.filter((item) => (check ? item.service_id !== id : item.id !== id));
        setServiceCurrentList(newCurrentService);

        const totalPriceSubService = newCurrentService.reduce((a, b) => (a += (+b.price - b.discount) * b.amount), 0);
        let totalPriceService = 0;
        if (totalPriceSubService) {
            totalPriceService = totalPriceSubService;
        }
        setTotalPrice(totalPriceService);
        if (!totalPriceService || totalPriceService < voucherSubmit?.minimum_price) {
            setVoucherSubmit({});
            localStorage.removeItem('voucherSubmit');
        }

        let newServiceList = serviceList;
        for (const item of newServiceList) {
            if (item.id === id) {
                item.amount = 1;
            }
        }
        setServiceList(newServiceList);
    };

    const CloseIcon = () => {
        return <img src={SVGS.IconClose} alt="IconClose" />;
    };

    const serviceTagsRender = (props) => {
        const childId = props.value;
        let item = {};

        for (const parent of categoryServiceList) {
            for (const child of parent.services) {
                if (child.id === childId) {
                    item = child;
                }
            }
        }

        return (
            <Tag
                key={item.id}
                closable
                onClose={(e) => handleClose(e, item.id)}
                className={cx('service-tag')}
                closeIcon={<CloseIcon />}
            >
                <span className={cx('tag-title')}>{item.title}</span>
            </Tag>
        );
    };

    const onFinish = (values) => {
        if (serviceCurrentList?.length || comboServiceSelected?.length) {
            const hour = moment(values.time).format('HH');
            const minute = moment(values.time).format('mm');

            const date_time = moment(values.date).startOf('day').add(hour, 'h').add(minute, 'm').valueOf();

            let items = [];
            for (const item of serviceCurrentList) {
                let temp = {
                    service_id: check ? item.service_id : item.id,
                    count: item.amount,
                };
                items.push(temp);
            }
            for (const item of comboServiceSelected) {
                let temp = {
                    order_item_id: item.order_item_id,
                    combo_id: item.combo_service_id,
                    service_id: item.service_id,
                    count: item.amount_order,
                };
                items.push(temp);
            }

            const data = {
                branch_id: branchSelected,
                name: userInfo?.fullname || '',
                phone: userInfo?.phone || phone_booking || '',
                email: userInfo?.email || '',
                time_start: date_time,
                message: values.message,
                booking_type: serviceCurrentList?.length ? payment : 'CASH',
                is_paid: serviceCurrentList?.length && payment === 'WALLET' ? true : false,
                items,
                // service_list_id: [...serviceIdList],
            };
            if (voucherSubmit?.id) {
                data.voucher_id = voucherSubmit?.id;
            }
            createBooking(data);
        } else {
            notification.open({
                message: 'Please select a service to schedule',
                duration: 2,
                placement: 'top',
            });
        }
    };

    const createBooking = async (data) => {
        if (disableSubmit) {
            return;
        } else {
            setDisableSubmit(true);
            try {
                const res = await bookingAPI.create(data);
                if (res.code === 200) {
                    setIsShowModalCreate(true);
                    setLatestBooking({ ...res.results.object });
                    // navigate(config.routes.home);
                    // notification.open({
                    // message: 'Schedule successful',
                    //     duration: 2,
                    //     placement: 'top',
                    // });
                }
                setDisableSubmit(false);
            } catch (error) {
                if (error.message) {
                    notification.open({
                        message: error.message,
                        duration: 2,
                        placement: 'top',
                    });
                }
                setDisableSubmit(false);
            }
        }
    };

    const handleShowVouchers = async () => {
        try {
            const Today = moment().startOf('day').format('x');

            const params = {
                fields: `["$all", {"voucher_users": ["$all"]}]`,
                filter: `{"$and": [{"voucher_type": "BOOKING"}, {"expiry": {"$gte":"${Today}"}}, {"amount": {"$gt":"0"}}]}`,
                order: '[["created_at","desc"]]',
                page: 1,
                limit: 100,
            };
            const res = await voucherAPI.getListVoucherAPI(params);
            setVoucherList(res?.results?.objects?.rows);
            if (!voucherSubmit?.id) {
                setVoucherSelected({});
            } else {
                setVoucherSelected(voucherSubmit);
            }
            setIsShowVouchers(true);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        if (voucherSubmit?.discount) {
            const discount = (totalPrice * voucherSubmit?.discount) / 100;
            if (voucherSubmit?.max_discount && voucherSubmit.max_discount < discount) {
                setPriceDiscount(voucherSubmit?.max_discount);
            } else {
                setPriceDiscount(discount);
            }
            setPricePayment(totalPrice - discount);
        } else {
            setPriceDiscount(0);
            setPricePayment(totalPrice);
        }
        // if (!totalPrice || totalPrice < voucherSubmit?.minimum_price) {
        //    //setVoucherSubmit({});
        //  //localStorage.removeItem('voucherSubmit');
        // }
    }, [voucherSubmit, totalPrice]);

    useEffect(() => {
        getListCategoryService();
        document.body.classList.add('time-picker-booking-custom');
        // eslint-disable-next-line
    }, [booking_id]);
    useEffect(() => {
        if (booking_id) {
            handleGetInfoBooking();
        }
        // eslint-disable-next-line
    }, [booking_id, categoryServiceList]);

    // const disabledHours = () => {
    //     const datePick = new Date(form.getFieldValue('date')).getDate();
    //     const dateCurr = new Date().getDate();
    //     const hours = [];
    //     let currentHour = moment().hour();
    //     let currentMinute = moment().minute();
    //     if (currentMinute >= 30) {
    //         currentHour++;
    //     }
    //     if (datePick === dateCurr) {
    //         for (let i = 0; i < currentHour; i += 1) hours.push(i);
    //     }

    //     return hours;
    // };

    // const disabledMinutes = (selectedHour) => {
    //     const minutes = [];
    //     if (selectedHour === moment().hour()) {
    //         for (let i = 0; i < moment().minute(); i += 1) minutes.push(i);
    //     }
    //     return minutes;
    // };

    const increaseAmount = (item) => {
        item.amount++;
        let newCurrentList = serviceCurrentList;
        for (const service of newCurrentList) {
            if (service.id === item.id) {
                service.amount = item.amount;
            }
        }
        setServiceCurrentList([...newCurrentList]);

        const totalPriceSubService = newCurrentList.reduce((a, b) => (a += (+b.price - b.discount) * b.amount), 0);
        let totalPriceService = 0;
        if (totalPriceSubService) {
            totalPriceService = totalPriceSubService;
        }
        setTotalPrice(totalPriceService);
        if (!totalPriceService || totalPriceService < voucherSubmit?.minimum_price) {
            setVoucherSubmit({});
            localStorage.removeItem('voucherSubmit');
        }

        let newServiceList = serviceList;
        for (const service of newServiceList) {
            if (service.id === item.id) {
                service.amount = item.amount;
            }
        }
        setServiceList([...newServiceList]);
    };
    const decreaseAmount = (item) => {
        let newCurrentList = serviceCurrentList;
        for (const service of newCurrentList) {
            if (service.id === item.id) {
                if (service.amount > 1) {
                    service.amount--;
                }
            }
        }
        setServiceCurrentList([...newCurrentList]);

        const totalPriceSubService = newCurrentList.reduce((a, b) => (a += (+b.price - b.discount) * b.amount), 0);
        let totalPriceService = 0;
        if (totalPriceSubService) {
            totalPriceService = totalPriceSubService;
        }
        setTotalPrice(totalPriceService);
        if (!totalPriceService || totalPriceService < voucherSubmit?.minimum_price) {
            setVoucherSubmit({});
            localStorage.removeItem('voucherSubmit');
        }
    };

    const onChangePayment = (e) => {
        setPayment(e.target.value);
    };

    // Combo service
    const [isShowComboServiceList, setIsShowComboServiceList] = useState(false);
    const [userComboServiceList, setUserComboServiceList] = useState([]);
    const [comboServiceSelected, setComboServiceSelected] = useState([]);

    const handleShowComboServiceList = () => {
        setIsShowComboServiceList(true);
    };

    const increaseAmountOrderComboService = (item) => {
        let comboServiceList = userComboServiceList;
        for (const comboService of comboServiceList) {
            for (const comboUsing of comboService?.combo_using) {
                if (
                    comboUsing.service_id === item.service_id &&
                    comboService.combo_service_id === item.combo_service_id &&
                    comboService.id === item.order_item_id
                ) {
                    if (comboUsing.amount_order < comboUsing.available_times) {
                        comboUsing.amount_order++;
                        comboUsing.available_times_temp--;
                    }
                    break;
                }
            }
        }
        setUserComboServiceList([...comboServiceList]);
        handleUpdateComboServiceSelected([...comboServiceList]);
    };
    const decreaseAmountOrderComboService = (item) => {
        let comboServiceList = userComboServiceList;
        for (const comboService of comboServiceList) {
            for (const comboUsing of comboService?.combo_using) {
                if (
                    comboUsing.service_id === item.service_id &&
                    comboService.combo_service_id === item.combo_service_id &&
                    comboService.id === item.order_item_id
                ) {
                    if (comboUsing.amount_order > 1) {
                        comboUsing.amount_order--;
                        comboUsing.available_times_temp++;
                    }
                    break;
                }
            }
        }
        setUserComboServiceList([...comboServiceList]);
        handleUpdateComboServiceSelected([...comboServiceList]);
    };

    const handleUpdateComboServiceSelected = (comboServiceList) => {
        let selected = [];
        for (const comboService of comboServiceList) {
            for (const comboUsing of comboService?.combo_using) {
                if (comboUsing.amount_order > 0) {
                    comboUsing.combo_service_title = comboService.title;
                    selected.push(comboUsing);
                }
            }
        }
        setComboServiceSelected([...selected]);
    };

    const getListBranch = async () => {
        try {
            const params = {
                fields: '["$all"]',
            };
            const res = await branchAPI.getBranchList(params);
            setBranchList(res?.results?.objects?.rows);
        } catch (err) {
            console.log(err);
            setBranchList([]);
        }
    };
    const renderOptionsBranch = (_arr = [], value, label) => {
        return _arr.map((item) => {
            return (
                <Select.Option value={item?.[value]} key={item?.[value]}>
                    {item?.[label]}
                </Select.Option>
            );
        });
    };
    const onChangeBranch = (val) => {
        setBranchSelected(val);
    };

    useEffect(() => {
        getListBranch();
        // eslint-disable-next-line
    }, []);

    const handleCloseComboService = (e, id) => {
        let newUserComboServiceList = userComboServiceList;

        for (const comboService of newUserComboServiceList) {
            for (const comboUsing of comboService.combo_using) {
                if (comboUsing.id === id) {
                    comboUsing.amount_order = 0;
                    comboUsing.available_times_temp = comboUsing.available_times;
                }
            }
        }
        setUserComboServiceList([...newUserComboServiceList]);

        let newComboServiceSelected = comboServiceSelected.filter((item) => item.id !== id);
        setComboServiceSelected([...newComboServiceSelected]);
    };
    const handleGetComboServiceByUser = async () => {
        try {
            const res = await comboServiceAPI.getListComboServiceOfUserAPI();
            let comboServiceList = res.results.objects.rows;
            let selected = [];

            for (const comboService of comboServiceList) {
                for (const comboUsing of comboService?.combo_using) {
                    comboUsing.amount_order = 0;
                    comboUsing.available_times_temp = comboUsing.available_times;
                    comboUsing.combo_service_title = comboService.title;
                    for (const oldCombo of oldComboServiceOrder) {
                        if (
                            oldCombo.service_id === comboUsing.service_id &&
                            oldCombo.combo_service_id === comboUsing.combo_service_id &&
                            oldCombo.order_item_id === comboUsing.order_item_id
                        ) {
                            comboUsing.amount_order = 1;
                            comboUsing.available_times_temp--;
                            selected.push(comboUsing);
                        }
                    }
                }
            }
            setUserComboServiceList([...comboServiceList]);
            setComboServiceSelected([...selected]);
        } catch (err) {
            console.log(err);
        }
    };
    // useEffect(() => {
    //     handleGetComboServiceByUser();
    // }, [booking_id, oldComboServiceOrder]);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangDatLaiLichDat');
        // eslint-disable-next-line
    }, []);

    // useEffect(() => {
    //     if (!isShowVouchers) {
    //         dispatch(updateInfoScheduleStore({}));
    //     }
    //     // eslint-disable-next-line
    // }, [isShowVouchers]);

    useEffect(() => {
        localStorage.setItem('totalPriceProductOrder', totalPrice);
        // eslint-disable-next-line
    }, [totalPrice]);

    return (
        <>
            {isLogin || phone_booking ? (
                <Layout className={cx('wrapper')} style={{ backgroundColor: '#fff' }}>
                    <Content>
                        <Breadcrumb className={cx('breadcrumb')}>
                            <Breadcrumb.Item>Service information</Breadcrumb.Item>
                            <Breadcrumb.Item className={cx('breadcrumbItemActive')}>Proceed to schedule</Breadcrumb.Item>
                        </Breadcrumb>
                        <div className={cx('headingBlock')}>
                            <h3>Schedule</h3>
                        </div>
                        <div className={cx('contentBlock')}>
                            <Form onFinish={onFinish} form={form} initialValues={initialValues}>
                                <Row gutter={16}>
                                    {/* Left */}
                                    <Col lg={12} md={24} xs={24}>
                                        <div className={cx('infoBlock')}>
                                            <div className={cx('heading')}>Branch</div>
                                            <Row gutter={[20, 16]}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name="branch"
                                                        className="mb-12"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please select a branch',
                                                            },
                                                        ]}
                                                    >
                                                        {/* <span style={{ display: 'none' }}>{branchSelected}</span> */}
                                                        <Select
                                                            placeholder="Affiliate *"
                                                            onChange={onChangeBranch}
                                                            value={branchSelected}
                                                        >
                                                            {renderOptionsBranch(branchList, 'id', 'name')}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className={cx('divider')}></div>
                                        <div className={cx('infoBlock')}>
                                            <div className={cx('heading')}>Time</div>
                                            <Row gutter={[20, 16]}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name="date"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please select a date',
                                                            },
                                                        ]}
                                                    >
                                                        <DatePicker
                                                            placeholder="Implementation date *"
                                                            locale={locale}
                                                            size="small"
                                                            disabledDate={disabledDate}
                                                            format="DD/MM/YYYY"
                                                            defaultValue={moment()}
                                                            value={moment()}
                                                            inputReadOnly={true}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name="time"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please select a time',
                                                            },
                                                        ]}
                                                    >
                                                        <TimePicker
                                                            placeholder="Execution hours *"
                                                            locale={locale}
                                                            size="small"
                                                            format="HH:mm"
                                                            inputReadOnly={true}
                                                            // disabledHours={disabledHours}
                                                            // disabledMinutes={disabledMinutes}
                                                            minuteStep={30}
                                                            showNow={false}
                                                            onSelect={(value) => {
                                                                // form.setFieldValue('time', value);
                                                                form.setFields([
                                                                    {
                                                                        name: 'time',
                                                                        value: value,
                                                                        errors: [],
                                                                    },
                                                                ]);
                                                            }}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className={cx('divider')}></div>
                                        <div className={cx('serviceBlock')}>
                                            {/* <div className={cx('heading')}>Select additional services</div> */}
                                            <Row align="middle" className={cx('heading')}>
                                                <Col xs={12}>
                                                    <Row align="middle">
                                                        <div>Choose additional services</div>
                                                    </Row>
                                                </Col>
                                                {/* {isLogin ? (
                                                    <Col xs={12}>
                                                        <Row align="middle" justify="end">
                                                            <div
                                                                className={cx('btn_show_combo_service')}
                                                                onClick={handleShowComboServiceList}
                                                            >
                                                                Service pack
                                                            </div>
                                                        </Row>
                                                    </Col>
                                                ) : null} */}
                                            </Row>
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <Select
                                                        mode="multiple"
                                                        placeholder="Choose service"
                                                        onChange={handleSelectService}
                                                        tagRender={serviceTagsRender}
                                                        listHeight={300}
                                                        value={serviceIdList}
                                                        // suffixIcon={<DownOutlined />}
                                                        showArrow
                                                        showSearch={false}
                                                    >
                                                        {categoryServiceList?.map((item) => (
                                                            <OptGroup
                                                                label={
                                                                    <h3
                                                                        className={cx('optionGroup', {
                                                                            'active-label': item.is_show,
                                                                        })}
                                                                        onClick={() => {
                                                                            handleShowServices(item.id);
                                                                        }}
                                                                    >
                                                                        {item.title}

                                                                        <span>
                                                                            {item.services?.length > 0 && (
                                                                                <img
                                                                                    src={SVGS.CheveronDown}
                                                                                    alt=""
                                                                                    className={cx('dropdown-icon', {
                                                                                        'rotate-icon-dropdown':
                                                                                            item.is_show,
                                                                                    })}
                                                                                />
                                                                            )}
                                                                        </span>
                                                                    </h3>
                                                                }
                                                                key={item.id}
                                                            >
                                                                {item.is_show &&
                                                                    item.services.map((subItem) => {
                                                                        return (
                                                                            <Option
                                                                                value={subItem.id}
                                                                                key={subItem.id}
                                                                                className={cx('child-option')}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className={cx('optionItemCheckbox')}
                                                                                    checked={
                                                                                        serviceIdList &&
                                                                                        serviceIdList.includes(
                                                                                            subItem.id,
                                                                                        )
                                                                                    }
                                                                                    readOnly
                                                                                />
                                                                                {subItem.title}&nbsp;
                                                                                <img
                                                                                    src={SVGS.IconSub}
                                                                                    alt=""
                                                                                    style={{ width: '10px' }}
                                                                                />
                                                                                &nbsp;
                                                                                {subItem.discount
                                                                                    ? `${getNumberWithCommas(
                                                                                        subItem.price -
                                                                                        subItem.discount,
                                                                                    )} ${subItem?.unit_id
                                                                                        ? `d/${subItem?.unit?.value}`
                                                                                        : 'd'
                                                                                    }`
                                                                                    : `${getNumberWithCommas(
                                                                                        subItem.price,
                                                                                    )} ${subItem?.unit_id
                                                                                        ? `d/${subItem?.unit?.value}`
                                                                                        : 'd'
                                                                                    }`}
                                                                            </Option>
                                                                        );
                                                                    })}
                                                            </OptGroup>
                                                        ))}
                                                    </Select>
                                                </Col>
                                            </Row>
                                            {/* {comboServiceSelected?.length ? (
                                                <Row
                                                    gutter={16}
                                                    style={{ margin: '20px 2px 2px 2px' }}
                                                    className={cx('container_tag_combo_service')}
                                                >
                                                    {comboServiceSelected?.map((item) => {
                                                        return (
                                                            <Tag
                                                                key={item.id}
                                                                closable
                                                                onClose={(e) => handleCloseComboService(e, item.id)}
                                                                className={cx('service-tag')}
                                                                closeIcon={<CloseIcon />}
                                                            >
                                                                <span className={cx('tag-title')}>
                                                                    {item?.service?.title}
                                                                </span>
                                                            </Tag>
                                                        );
                                                    })}
                                                </Row>
                                            ) : null} */}
                                        </div>
                                        <div className={cx('divider')}></div>
                                        <div className={cx('serviceBlock')}>
                                            <Row className={cx('heading', 'row_voucher')} onClick={handleShowVouchers}>
                                                <Col xs={16}>
                                                    <Row align="middle">
                                                        <img src={SVGS.IconVoucher} alt="" />
                                                        <span>
                                                            Discount code
                                                            {voucherSubmit?.id ? (
                                                                <span className={cx('tag_discount')}>
                                                                    -{voucherSubmit?.discount}%
                                                                </span>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </span>
                                                    </Row>
                                                </Col>
                                                <Col xs={8}>
                                                    <Row justify="end">
                                                        <img src={SVGS.IconArrowRightBlack} alt="" />
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <Row>
                                                {voucherSubmit?.id ? (
                                                    <div className={cx('voucher_apply')}>
                                                        Discount: {getNumberWithCommas(priceDiscount)} d
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                                {/* {voucherSubmit?.id ? (
                                                    <div className={cx('voucher_apply')}>{voucherSubmit?.name}</div>
                                                ) : (
                                                    ''
                                                )} */}
                                            </Row>
                                        </div>
                                        <div className={cx('divider')}></div>
                                        <div className={cx('serviceBlock')}>
                                            <div className={cx('heading')}>Payment method</div>
                                            <Row>
                                                <Radio.Group onChange={onChangePayment} value={payment}>
                                                    <Space direction="vertical">
                                                        {payments?.map((item) => {
                                                            return (
                                                                <Radio
                                                                    value={item.value}
                                                                    disabled={
                                                                        (!isLogin && item.id === 3) ||
                                                                            !serviceCurrentList?.length
                                                                            ? true
                                                                            : false
                                                                    }
                                                                >
                                                                    {item.title}
                                                                </Radio>
                                                            );
                                                        })}
                                                    </Space>
                                                </Radio.Group>
                                            </Row>
                                        </div>
                                        <div className={cx('divider')}></div>
                                        <div className={cx('serviceBlock')}>
                                            <div className={cx('heading')}>Special Requirements</div>
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <Form.Item name="message">
                                                        <TextArea
                                                            placeholder="Write special request"
                                                            rows={3}
                                                            maxLength={255}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>

                                    {/* Right */}
                                    <Col lg={12} md={24} xs={24}>
                                        <div className={cx('infoBlock')}>
                                            <div className={cx('heading')}>Schedule information</div>
                                            <div className={cx('infoBooking')}>
                                                <div className={cx('headingInfoBooking')}>
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className={cx('titleInfoBooking')}>
                                                                <Row gutter={16}>
                                                                    <Col xs={8} md={11}>
                                                                        <span className={cx('nameService')}>
                                                                            Service
                                                                        </span>
                                                                    </Col>
                                                                    <Col xs={8} md={6}>
                                                                        <Row justify="center">
                                                                            <span className={cx('time-title')}>
                                                                                Quantity
                                                                            </span>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col xs={8} md={7} style={{ textAlign: 'right' }}>
                                                                        <span>Price</span>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className={cx('contentInfoBooking')}>
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className={cx('titleInfoBooking')}>
                                                                <Row gutter={[16, 10]}>
                                                                    {serviceCurrentList?.map((item) => (
                                                                        <Fragment key={item?.id}>
                                                                            <Col xs={8} md={11} lg={9} xl={11}>
                                                                                <span>{item?.title}</span>
                                                                            </Col>
                                                                            <Col xs={8} md={6} lg={8} xl={6}>
                                                                                <Row justify="center" align="middle">
                                                                                    <div className={cx()}></div>
                                                                                    <div className={cx('button_count')}>
                                                                                        <img
                                                                                            src={SVGS.IconSub}
                                                                                            alt=""
                                                                                            onClick={() =>
                                                                                                decreaseAmount(item)
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                    <span className={cx('count')}>
                                                                                        {item?.amount}
                                                                                    </span>
                                                                                    <div className={cx('button_count')}>
                                                                                        <img
                                                                                            src={SVGS.IconPlus}
                                                                                            alt=""
                                                                                            onClick={() =>
                                                                                                increaseAmount(item)
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                </Row>
                                                                            </Col>
                                                                            <Col
                                                                                xs={8}
                                                                                md={7}
                                                                                style={{ textAlign: 'right' }}
                                                                            >
                                                                                <span>
                                                                                    {getNumberWithCommas(
                                                                                        item?.price - item?.discount,
                                                                                    )}
                                                                                    &nbsp;
                                                                                    {item?.unit_id
                                                                                        ? `d/${item?.unit?.value}`
                                                                                        : 'd'}
                                                                                </span>
                                                                            </Col>
                                                                        </Fragment>
                                                                    ))}
                                                                </Row>
                                                                <Row gutter={[16, 10]}>
                                                                    {comboServiceSelected?.map((item) => (
                                                                        <Fragment key={item?.id}>
                                                                            <Col
                                                                                xs={8}
                                                                                md={11}
                                                                                lg={9}
                                                                                xl={11}
                                                                                style={{ overflow: 'hidden' }}
                                                                            >
                                                                                <span className={cx('tag-title')}>
                                                                                    {item?.service?.title}
                                                                                </span>
                                                                            </Col>
                                                                            <Col xs={8} md={6} lg={8} xl={6}>
                                                                                <Row justify="center" align="middle">
                                                                                    <div className={cx()}></div>
                                                                                    <div
                                                                                        className={cx(
                                                                                            item.amount_order > 1
                                                                                                ? 'button_count'
                                                                                                : 'button_count_disable',
                                                                                        )}
                                                                                        onClick={() =>
                                                                                            decreaseAmountOrderComboService(
                                                                                                item,
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <img
                                                                                            src={SVGS.IconSub}
                                                                                            alt=""
                                                                                        />
                                                                                    </div>
                                                                                    <span className={cx('count')}>
                                                                                        {item?.amount_order}
                                                                                    </span>
                                                                                    <div
                                                                                        className={cx(
                                                                                            item.amount_order <
                                                                                                item.available_times
                                                                                                ? 'button_count'
                                                                                                : 'button_count_disable',
                                                                                        )}
                                                                                        onClick={() =>
                                                                                            increaseAmountOrderComboService(
                                                                                                item,
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <img
                                                                                            src={SVGS.IconPlus}
                                                                                            alt=""
                                                                                        />
                                                                                    </div>
                                                                                </Row>
                                                                            </Col>
                                                                            <Col
                                                                                xs={8}
                                                                                md={7}
                                                                                style={{
                                                                                    textAlign: 'right',
                                                                                    overflow: 'hidden',
                                                                                }}
                                                                            >
                                                                                <span
                                                                                    className={cx('tag_combo_service')}
                                                                                >
                                                                                    {item?.combo_service_title}
                                                                                </span>
                                                                            </Col>
                                                                        </Fragment>
                                                                    ))}
                                                                </Row>
                                                                {!serviceCurrentList?.length &&
                                                                    !comboServiceSelected?.length && (
                                                                        <Row gutter={[16, 10]}>
                                                                            The old service no longer exists!
                                                                        </Row>
                                                                    )}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                {/* <div className={cx('headingInfoBooking')}>
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className={cx('titleInfoBooking')}>
                                                    <Row gutter={16}>
                                                        <Col span={12}>
                                                            <span className={cx('nameService')}>
                                                                Payment methods
                                                            </span>
                                                        </Col>
                                                        <Col span={12} style={{ textAlign: 'right' }}>
                                                            <span>Cash payment</span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div> */}
                                                <div className={cx('contentInfoBooking')}>
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className={cx('titleInfoBooking')}>
                                                                <Row gutter={16}>
                                                                    <Col span={12}>
                                                                        <span className={cx('total-title')}>
                                                                            Total service fee
                                                                        </span>
                                                                    </Col>
                                                                    <Col span={12} style={{ textAlign: 'right' }}>
                                                                        <span className={cx('total-price')}>
                                                                            {getNumberWithCommas(totalPrice)} d
                                                                        </span>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                        <Col span={24}>
                                                            <div className={cx('titleInfoBooking')}>
                                                                <Row gutter={16}>
                                                                    <Col span={12}>
                                                                        <span className={cx('total-title')}>
                                                                            Discount
                                                                        </span>
                                                                    </Col>
                                                                    <Col span={12} style={{ textAlign: 'right' }}>
                                                                        <span className={cx('total-price')}>
                                                                            {getNumberWithCommas(priceDiscount)} d
                                                                        </span>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                        <Col span={24}>
                                                            <div className={cx('titleInfoBooking')}>
                                                                <Row gutter={16}>
                                                                    <Col span={12}>
                                                                        <span className={cx('total-title')}>
                                                                            Total payment
                                                                        </span>
                                                                    </Col>
                                                                    <Col span={12} style={{ textAlign: 'right' }}>
                                                                        <span className={cx('total-price')}>
                                                                            {getNumberWithCommas(pricePayment)} d
                                                                        </span>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                {/* <button className={cx('btnBooking')}>Book now</button> */}
                                                <Button
                                                    type="primary"
                                                    className={cx('btnBooking')}
                                                    disabled={disableSubmit}
                                                    htmlType={'submit'}
                                                >
                                                    Book now
                                                </Button>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Content>
                    {isShowComboServiceList && (
                        <Modal
                            centered
                            visible={isShowComboServiceList}
                            onCancel={() => setIsShowComboServiceList(false)}
                            maskClosable={false}
                            footer={null}
                            className="otp-modal"
                            width={800}
                        // bodyStyle={{ height: '600px', overflow: 'auto' }}
                        >
                            <div style={{ padding: '20px 20px' }}>
                                <ComboServiceBooking
                                    userComboServiceList={userComboServiceList}
                                    setUserComboServiceList={setUserComboServiceList}
                                    comboServiceSelected={comboServiceSelected}
                                    setComboServiceSelected={setComboServiceSelected}
                                    setIsShowComboServiceList={setIsShowComboServiceList}
                                />
                            </div>
                        </Modal>
                    )}
                    {isShowModalCreate && (
                        <Modal
                            centered
                            visible={isShowModalCreate}
                            onCancel={() => {
                                setIsShowModalCreate(false);
                                navigate(config.routes.home);
                            }}
                            maskClosable={false}
                            footer={null}
                            className="otp-modal"
                            width={800}
                        // bodyStyle={{ height: '600px', overflow: 'auto' }}
                        >
                            <div style={{ padding: '20px 20px' }}>
                                <CreateScheduleModal latestBooking={latestBooking} />
                            </div>
                        </Modal>
                    )}{' '}
                    {isShowVouchers && (
                        <Modal
                            centered
                            visible={isShowVouchers}
                            onCancel={() => setIsShowVouchers(false)}
                            maskClosable={false}
                            footer={null}
                            className="otp-modal"
                            width={580}
                        >
                            <div>
                                <VouchersModal
                                    voucherList={voucherList}
                                    voucherSelected={voucherSelected}
                                    setVoucherSelected={setVoucherSelected}
                                    setVoucherSubmit={setVoucherSubmit}
                                    setIsShowVouchers={setIsShowVouchers}
                                    totalPriceProductOrder={totalPrice}
                                    updateInfoSchedule={updateInfoSchedule}
                                />
                            </div>
                        </Modal>
                    )}
                </Layout>
            ) : (
                <PageNotFound />
            )}
        </>
    );
}
